export default __webpack_public_path__ + "static/do-fade-slide-flag-978cd64f4323aa4c0532801144c840c0.png";